import * as React from 'react';

type Props = {
  width?: string;
  height?: string;
  color?: 'default' | 'invert';
};

/**
 * MUI icon for "arrow forward"
 */
const ArrowForward = ({ width = '16', height = '16', color = 'default' }: Props) => (
  <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.6531 8.875H1V7.125H11.6531L6.75312 2.225L8 1L15 8L8 15L6.75312 13.775L11.6531 8.875Z"
      fill={color === 'invert' ? '#FFFFFF' : '#1E2229'}
    />
  </svg>
);

export default ArrowForward;
